import React from 'react';
import {Field} from 'redux-form';
import {Form, Row, Col} from 'react-bootstrap';
import Button from '@material-ui/core/Button';
import {isEmpty} from 'lodash/lang';
import * as fields from 'components/common/fields';
import * as validators from 'utils/validators';
import {makeForm, formatTipType, levelMap} from 'utils/common';

class TipForm extends React.Component {
  constructor(props) {
    super(props);
    this.types = [
      {value: 'kluwell_admin', label: 'Kluwell Admin'},
      {value: 'school_coordinator', label: 'School Coordinator'},
      {value: 'teacher', label: 'Teacher'},
      {value: 'parent', label: 'Parent'},
      {value: 'reader', label: 'Student'},
      {value: 'book', label: 'Book'},
    ];
  }

  render() {
    const {type, handleSubmit, pristine, submitting} = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col md={6}>
            <Field name="title" label="Title" component={fields.Input} required validate={[validators.isRequired]} />
          </Col>
          <Col md={6}>
            <Field
              name="type"
              label="Type"
              labelKey="label"
              valueKey="value"
              component={fields.Select}
              options={this.types}
              required
              validate={[validators.isRequired]}
            />
          </Col>
          <Col md={6}>
            <Field
              name="level"
              label="Level"
              labelKey="label"
              valueKey="value"
              component={fields.Select}
              defaultValue={{value: 0, label: 'All Level'}}
              options={[
                {value: 0, label: 'All Level'},
                {value: 1, label: 'Yellow'},
                {value: 2, label: 'Green'},
                {value: 3, label: 'Orange'},
              ]}
              required
              validate={[validators.isRequired]}
            />
          </Col>
          <Col md={12}>
            <Field name="body" label="Body" component={fields.Textarea} required validate={[validators.isRequired]} />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth disabled={pristine || submitting}>
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {tip} = ownProps;
  return {
    initialValues: {
      ...tip,
      type: {value: tip.type, label: formatTipType(tip.type)},
      level: {value: tip.level || 0, label: !tip.level ? 'All Level' : levelMap[tip.level]},
    },
  };
};

export default {
  Creation: makeForm(TipForm, 'TipForm.Creation', null, null, ['type']),
  Update: makeForm(TipForm, 'TipForm.Update', mapStateToProps, null, ['type']),
};
